module.exports = __webpack_public_path__ + "media/woonbox.ed91793d.mp4";